import { render } from "./DefShowMore.vue?vue&type=template&id=8041d994&scoped=true"
import script from "./DefShowMore.vue?vue&type=script&lang=js"
export * from "./DefShowMore.vue?vue&type=script&lang=js"

import "./DefShowMore.vue?vue&type=style&index=0&id=8041d994&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8041d994"]])

export default __exports__